import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { getNFLImpactfulPlayers } from '../../data/nflImpactfulPlayers';

function NFLHardcodedImpactfulPlayers({ teamName }) {
	const players = getNFLImpactfulPlayers(teamName);
	if (!players) return null;

	const renderPlayer = (player, key) => (
		<Col lg={6} key={key}>
			<div className='matchPlayerDiv'>
				<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
					<p className='matchPlayerInfoNameTop'>{player.name}</p>
					<p className='matchPlayerInfoInjury'>
						<span className='grey'>POSITION:</span>
						<span className='matchPlayerInfo'>{player.position}</span>
					</p>
				</div>
			</div>
		</Col>
	);

	return (
		<div className='matchupHeaderDiv'>
			<p style={{ fontWeight: 'bold', marginBottom: '6px', textAlign: 'center', fontSize: '20px' }}>Offense</p>
			<Row>
				{players.offense.map((p, i) => renderPlayer(p, `o${i}`))}
			</Row>
			<p style={{ fontWeight: 'bold', marginBottom: '6px', marginTop: '10px', textAlign: 'center', fontSize: '20px' }}>Defense</p>
			<Row>
				{players.defense.map((p, i) => renderPlayer(p, `d${i}`))}
			</Row>
		</div>
	);
}

export default NFLHardcodedImpactfulPlayers;
